import React from 'react';
import {
  MDBCol,
  MDBRow,
  MDBInput,
  MDBModal,
  MDBNavLink,
  MDBModalFooter,
  MDBModalBody,
  MDBModalHeader,
  MDBDataTable,
  MDBListGroup, MDBListGroupItem,
  MDBContainer, MDBInputGroup,
  MDBBtn
} from 'mdbreact';
import './entities-view.css';
import '../../styles/page-common.css';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import { Redirect, Link } from "react-router-dom";
import SpinnerView from '../../components/spinner/spinner-view';
import DownloadLink from "react-download-link";
import urls from '../../network/urls';
import EntityComponent from '../../components/entityComponent';
import { format } from '../../helpers/invoiceNumber';

class EntityView extends React.Component {

  state = {
    modal: false,
    newEntity: {},
    showAdd: false,
    rankType: 'all'
  }

  componentDidMount() {
    if (this.props.selectedCompanyId) {
      this.props.dispatchGetEntities();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.selectedCompanyId && this.props.selectedCompanyId !== prevProps.selectedCompanyId) {
      this.props.dispatchGetEntities();
    }
  }


  setRank = (rank) => {
    this.setState({
      rankType: rank
    });
  }

  updateshowAdd = (showAdd) => {
    this.setState({ showAdd });
    if (!showAdd) {
      // Reload entities when returning to list
      this.props.dispatchGetEntities();
    }
  }

  getDataFromURL = (url, user) => new Promise((resolve, reject) => {
    setTimeout(() => {
      let req = {
        headers: {
          username: user.username,
          token: user.token,
          AUTHORIZATION: user.token
        },
        method: 'GET'
      }

      fetch(url, req)
        .then(response => response.blob())
        .then(data => {
          resolve(data)
        });
    });
  }, 2000);

  render() {

    let totalU = 0;

    if (this.props.user && !this.props.user._id) {
      return <Redirect to='/' />
    }

    var Entity = [];

    if (this.props.entities && this.props.entities.length > 0) {
      Entity = this.props.entities.map(p => {
        totalU += p.outstanding;
        return {
          entityTemplateId: p.entityTemplateId,
          name: p.name + ' ' + (p.surname ?? ''),
          outstanding: 'R ' + format(p.outstanding),
          view: <button type='button' className='btn btn-sm btn-info' onClick={() => {
            this.props.dispatchGetEntity(p._id, loaded);
            let updateshowAdd = this.updateshowAdd;
            function loaded(error) {
              updateshowAdd(true);
            }

          }}>
            View
          </button>
        }
      }).filter(i => {
        if (this.state.rankType == 'all') return true;
        else return i.entityTemplateId == this.state.rankType
      });
    }

    const downloadFile = ({ data, fileName, fileType }) => {
      const blob = new Blob([data], { type: fileType })

      const a = document.createElement('a')
      a.download = fileName
      a.href = window.URL.createObjectURL(blob)
      const clickEvt = new MouseEvent('click', {
        view: window,
        bubbles: true,
        cancelable: true,
      })
      a.dispatchEvent(clickEvt)
      a.remove()
    }

    const exportToCsv = e => {
      e.preventDefault()

      let headers = Object.keys(this.props.entities[0]);

      headers = headers.filter(i => i != 'entityTemplateId' && i != 'userId' && i != 'companyId' && i != 'statementTemplateId');


      downloadFile({
        data: [headers.join(';'), ...this.props.entities.map(t => {
          let l = [];
          headers.forEach(h => {
            l.push(t[h]);
          });
          return l.join(';');
        })].join('\n'),
        fileName: 'Clients.csv',
        fileType: 'text/csv',
      })
    }

    const data = {
      columns: [
        {
          label: 'Name',
          field: 'name',
          sort: 'asc'
        },
        {
          label: 'Outstanding',
          field: 'outstanding',
          sort: 'asc'
        },
        {
          label: '',
          field: 'view',
          sort: 'asc'
        }
      ],
      rows: Entity
    };

    return (
      <div className="content-wrapper">
        <SpinnerView showSpinner={this.props.loading} />

        {/* Page Header */}
        {!this.state.showAdd && (
          <div className="page-header">
            <h1 className="page-title">
              <i className="fas fa-users"></i>
              Clients
            </h1>
          </div>
        )}

        {this.state.showAdd && (
          <div style={{ margin: '16px 20px' }}>
            <div style={{ background: '#fff', borderRadius: 8, boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)', overflow: 'hidden' }}>
              <EntityComponent updateshowAdd={this.updateshowAdd} />
            </div>
          </div>
        )}

        {!this.state.showAdd && (
          <div className="entity-toolbar">
            {/* New Button */}
            <button
              className="entity-toolbar-btn primary"
              data-testid="entity-new"
              onClick={() => {
                this.props.dispatchSelectEntity(undefined);
                this.updateshowAdd(true);
              }}
            >
              <i className="fas fa-plus"></i>
              New
            </button>

            <div className="entity-toolbar-divider"></div>

            {/* Export Buttons */}
            <button className="entity-toolbar-btn secondary" onClick={exportToCsv}>
              <i className="fas fa-download"></i>
              Export CSV
            </button>

            <DownloadLink
              label={<><i className="fas fa-file-excel"></i> Export Excel</>}
              className="entity-toolbar-btn secondary"
              style={{ textDecoration: 'none', cursor: 'pointer' }}
              filename={"client_export.xlsx"}
              exportFile={() => {
                let url = urls.getEntities(this.props.selectedCompanyId) + '/export';
                return Promise.resolve(this.getDataFromURL(url, this.props.user))
              }}
            />

            <div className="entity-toolbar-divider"></div>

            {/* Filter Buttons */}
            <div className="entity-toolbar-group">
              <button
                className={`entity-toolbar-btn filter ${this.state.rankType === 'all' ? 'active' : ''}`}
                onClick={() => this.setRank('all')}
              >
                All
              </button>

              {this.props.templates && this.props.templates.map((item) => (
                <button
                  key={item._id}
                  className={`entity-toolbar-btn filter ${this.state.rankType === item._id ? 'active' : ''}`}
                  onClick={() => this.setRank(item._id)}
                >
                  {item.entityTemplateName}
                </button>
              ))}
            </div>
          </div>
        )}

        {/* Content Card with Stats and Table */}
        {!this.state.showAdd && (
          <div className="entity-content-card">
            {/* Stats Row */}
            <div className="entity-stats-row">
              <div className="entity-stat-item outstanding">
                <div className="entity-stat-icon">
                  <i className="fas fa-dollar-sign"></i>
                </div>
                <div className="entity-stat-content">
                  <span className="entity-stat-label">Total Outstanding</span>
                  <span className="entity-stat-value">R {format(totalU)}</span>
                </div>
              </div>
              <div className="entity-stat-item clients">
                <div className="entity-stat-icon">
                  <i className="fas fa-users"></i>
                </div>
                <div className="entity-stat-content">
                  <span className="entity-stat-label">Total Clients</span>
                  <span className="entity-stat-value">{Entity.length}</span>
                </div>
              </div>
            </div>

            {/* Table */}
            <div className="entity-table-desktop">
              <MDBDataTable
                disableRetreatAfterSorting={true}
                striped
                bordered
                small
                data={data}
              />
            </div>
          </div>
        )}

      </div>
    );
  }
}

export default EntityView;
